// frontend/src/pages/learning/AssignmentTopics.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './styles/AssignmentTopics.css';
import topics from './OtherAssignmentTopicList';

const OtherAssignmentTopics = () => {
    const [index, setIndex] = useState(0);

    return (
        <div className="mx-auto my-4 p-4 bg-black text-white [&_p]:text-white">
            <div className="grid gap-6">
                {topics.reduce((acc, topic, index) => {
                    if (index === 0 || topic.topictype !== topics[index - 1].topictype) {
                        acc.push(
                            <div
                                key={topic.topictype}
                                className="py-2 px-4 text-m lg:text-lg font-semibold text-teal-500 rounded-md shadow-md"
                            >
                                Select your {topic.topictype} assignment topic
                            </div>
                        );
                    }
                    acc.push(
                        <div
                            key={index}
                            className="p-4 bg-black hover:bg-gray-800 rounded-md shadow transition-all duration-200"
                        >
                            <Link
                            to={`/otherAssignments/add?owner=${encodeURIComponent(topic.owner)}&code=${encodeURIComponent(topic.code)}&title=${encodeURIComponent(topic.title)}&topictype=${encodeURIComponent(topic.topictype)}&desc=${encodeURIComponent(topic.desc)}`}
                            className="block"
                            >
                                <div className="mb-2 text-m lg:text-lg font-bold text-yellow-200">
                                    {topic.sn}. {topic.title}
                                </div>
                                <div
                                    className="text-white text-sm lg:text-m"
                                    dangerouslySetInnerHTML={{ __html: topic.desc }}
                                ></div>
                            </Link>
                        </div>
                    );

                    return acc;
                }, [])}
            </div>
        </div>
    );
};

export default OtherAssignmentTopics;
